/**
 * Abstracts integration APIs. Based on initApi parameters,
 * returns dummy API or particular API, like ShopifyAPI
 */
import * as integrationType from 'constants/integrationType'
import dummyAPI from './dummyAPI'
import ShopifyAPI from './shopifyAPI'
import { setIntegrationProducts } from 'actions/integrationProductsAC'

export let api

export function cancel () {
  if (api) api.cancel()
}

export function initApi (appId, integration, onInitialized, dispatch = () => null, productIds = []) {
  console.log('INIT API')
  cancel()
  if (integration) {
    switch (integration.type) {
      case integrationType.SHOPIFY:
        if (!api || (api.checkParams && !api.checkParams(appId, integration.shopName))) {
          api = new ShopifyAPI(appId, integration.shopName, onInitialized, dispatch, productIds)
          // dispatch(setIntegrationProducts([]))
          api.init()
        } else if (api.updateDispatch) {
          api.updateDispatch(dispatch)
          onInitialized(true)
          console.log('INIT API ignored, already initialized')
        }
        break
      default:
        api = dummyAPI
        dispatch(setIntegrationProducts([]))
        onInitialized(true)
    }
  } else {
    api = dummyAPI
    dispatch(setIntegrationProducts([]))
    onInitialized(true)
  }
}



// WEBPACK FOOTER //
// ./src/api/integrationAPI.js